export default __webpack_public_path__ + "static/vm-780-da8ac6c90ff07158d43af10c0004eb0d.png";